import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  // Métodos para localStorage
  setLocalStorageItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.warn('localStorage not available:', error);
      }
    }
  }

  getLocalStorageItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      try {
        return localStorage.getItem(key);
      } catch (error) {
        console.warn('localStorage not available:', error);
        return null;
      }
    }
    return null;
  }

  removeLocalStorageItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.warn('localStorage not available:', error);
      }
    }
  }

  clearLocalStorage(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.clear();
      } catch (error) {
        console.warn('localStorage not available:', error);
      }
    }
  }

  // Métodos para sessionStorage
  setSessionStorageItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {
        console.warn('sessionStorage not available:', error);
      }
    }
  }

  getSessionStorageItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        console.warn('sessionStorage not available:', error);
      }
    }
    return null;
  }

  removeSessionStorageItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        console.warn('sessionStorage not available:', error);
      }
    }
  }

  clearSessionStorage(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        sessionStorage.clear();
      } catch (error) {
        console.warn('sessionStorage not available:', error);
      }
    }
  }

  // Método para verificar si estamos en el navegador
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  // Método seguro para obtener elementos del DOM
  getElementById(id: string): HTMLElement | null {
    if (isPlatformBrowser(this.platformId)) {
      try {
        return document.getElementById(id);
      } catch (error) {
        console.warn('document not available:', error);
        return null;
      }
    }
    return null;
  }
}
